module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Preface")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("I am fascinated by the Acts of the Apostles. It is the only account we have of how the first Christians spread and multiplied during the thirty years following the death of Jesus. By that time they had become so numerous that the Fire of Rome in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 64 could be attributed, albeit slanderously, to them. The book contains a tapestry of themes: the church, the ministry, the apostolic preaching, the Spirit, the charismata, church planting, Christian lifestyle, sacrifice, prayer, social concern and many more. The Acts has so much to say to our half-hearted and cold-blooded Christianity in the western world. It rebukes our preoccupation with buildings and ministerial pedigree, our syncretism and pluralism, our lack of expectancy and vibrant faith. As such it is a book supremely relevant for our time.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("I have tried to learn principles of Christian life and ministry from this book for many years. They are so radical so different from much that is taught and practised in the modern church. They are so difficult to carry out. Time and again I fall flat on my face. But better to try and to fail than not to try at all. It gives me a renewed zest to return to the book of Acts afresh, keen to discern more clearly the secret of the astonishing advance of the early church. So I have taken some major themes from the book and examined their relevance to today’s church. And I am very grateful for churches I know in many ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("parts of the world, mainly the Two Thirds World, which are seeking to live like the first disciples and, like them, are discovering the power of the Holy Spirit who seems only to be available to us when we make ourselves totally available to God")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This book examines different elements in the impact which the first century Christians made on the world of their day. I see no reason why, if we are prepared to pay the price and follow their example, the gospel they proclaimed and embodied should not again transform society. Few things are more needed than that.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-aut-t"
  }, [_c('em', [_vm._v("Michael Green")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-aut"
  }, [_c('em', [_vm._v("Wycliffe Hall, Oxford University")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-386c7780","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Preface.vue
// module id = 75
// module chunks = 0